import { render, staticRenderFns } from "./ReviewSettings.vue?vue&type=template&id=9ddd15e6&scoped=true&"
import script from "./ReviewSettings.vue?vue&type=script&lang=js&"
export * from "./ReviewSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddd15e6",
  null
  
)

export default component.exports